/* istanbul ignore file */
/* eslint-disable no-console */
import * as Sentry from '@sentry/react';
import { isProduction } from 'src/utils/isProduction';

export const error = (error: Error, message?: string) => {
  if (isProduction()) {
    Sentry.captureException(error);
  } else {
    console.error(error);
    if (message) {
      console.log(message);
    }
  }
};

export const info = (tag: string, message: string) => {
  if (!isProduction()) {
    console.info(`${tag}: ${message}`);
  }
};
